export const eventBetConstants = {
    EVENT_BETS_REQUEST: 'EVENT_BETS_REQUEST',
    EVENT_BETS_SUCCESS: 'EVENT_BETS_SUCCESS',
    EVENT_BETS_FAILURE: 'EVENT_BETS_FAILURE'
};